import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import AppToast from "./components/AppToast";
import "./styles/pixel.css";
// import "./styles/route-transition.css";
import "./styles/toast.css";
import { AuthProvider } from "./auth/AuthContext";
import MyForms from "./pages/MyForms.jsx";
import MerchantConfig from "./pages/MerchantConfig.jsx";
import PublicForm from "./pages/PublicForm.jsx";
import EditForm from "./pages/EditForm.jsx";
import CreateForm from "./pages/CreateForm.jsx";
import ModernPaymentReceipt from "./pages/ModernPaymentReceipt.jsx";
import ProtectedRoute from "./ProtectedRoute"; // ✅ import wrapper
import ErrorPage from "./components/ErrorPage.jsx";
import BulkUploadPage from "./pages/BulkUploadPage.jsx";
import MerchantDashboard from "./pages/MerchantDashboard.jsx";

export default function App() {
  const location = useLocation();

  return (
    <AuthProvider>
      <AppToast />
      <div className="route-wrapper">
        <Routes location={location} key={location.pathname}>
          <Route path="/login" element={<Login />} />
          {/* ✅ Wrap protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/create-form"
            element={
              <ProtectedRoute>
                <CreateForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/merchant-config"
            element={
              <ProtectedRoute>
                <MerchantConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-forms"
            element={
              <ProtectedRoute>
                <MyForms />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload-master-data"
            element={
              <ProtectedRoute>
                <BulkUploadPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/all-transactions"
            element={
              <ProtectedRoute>
                <MerchantDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:slug/receipt/:transactionId"
            element={
              <ProtectedRoute>
                <ModernPaymentReceipt />
              </ProtectedRoute>
            }
          />
          <Route
            path="/builder/:slug"
            element={
              <ProtectedRoute>
                <EditForm />
              </ProtectedRoute>
            }
          />
          {/* Public routes */}
          <Route path="/forms/:slug" element={<PublicForm />} />
          <Route
            path="/receipt/:transactionId"
            element={<ModernPaymentReceipt />}
          />
          <Route path="/error/:code" element={<ErrorPage />} />
          <Route path="/error/network" element={<ErrorPage />} />
          <Route path="/error/unexpected" element={<ErrorPage />} /> =
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}
